import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

import './style.scss';

const SocialMenu = () => {
  const { t } = useTranslation();
  return (
    <div className="SocialMenu">
      <h3>{t('general.social_share_header')}</h3>
      <Menu id="social-menu">
        {(items) => {
          return (
            <>
              {items.map((item) => {
                if (item) {
                  const className = item.getIn(['link', 'options', 'attributes', 'class'], []).join(' ');
                  const title = item.getIn(['link', 'title'], 'Untitled');
                  const url = item.getIn(['link', 'url'], '');

                  return (
                    <div key={title} className="SocialMenu__item">
                      <CoreLink
                        className="SocialMenu__item__link"
                        to={url}
                      >
                        <span className={`icon icon-${className}`} />
                      </CoreLink>
                    </div>
                  );
                }
              })}
            </>
          );
        }}
      </Menu>
    </div>
  );
};

export default SocialMenu;
